import { Component } from '@angular/core';

@Component({
  selector: 'app-filter-container-loading',
  templateUrl: './filter-container-loading.component.html',
  styleUrls: ['./filter-container-loading.component.scss'],
})
export class FilterContainerLoadingComponent {}
